var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "pushRightSidebar--main order-details p-20 order-container",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "order-details-infos p-20 bg-bo-grey4 radius-5 radius-bottom-0",
          },
          [
            _vm.order.quote
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "d-flex gap-2 mb-10" },
                    [
                      _vm._v("Devis signé: "),
                      _c("Switch2", {
                        attrs: { value: _vm.order.quote.signed },
                        on: { input: _vm.quoteSigned },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "order-details--shop-client flex-between-start fsize-12",
              },
              [
                _c("div", { staticClass: "shop-details color-grey2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "color-grey1 text-uppercase mb-15 text-bold",
                    },
                    [_vm._v("Infos établissement")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "shop-details--name mb-5" }, [
                    _c("a", { attrs: { href: _vm.order.shop.ShopId } }, [
                      _vm._v(_vm._s(_vm.order.shop.DefaultName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "shop-details--phone mb-5" }, [
                    _c("a", { attrs: { href: "tel:" + _vm.order.shop.Tel } }, [
                      _vm._v(_vm._s(_vm.order.shop.Tel)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "shop-details--address mb-5" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.order.shop.Address1) +
                        " " +
                        _vm._s(_vm.order.shop.Address2) +
                        ",\n\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "shop-details--city mb-5" }, [
                    _vm._v(
                      _vm._s(_vm.order.shop.Zip) +
                        " " +
                        _vm._s(_vm.order.shop.City)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "client-details color-grey2 text-right" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-grey1 text-uppercase mb-15 text-bold",
                      },
                      [_vm._v("Infos client")]
                    ),
                    _vm._v(" "),
                    _vm.canChangeClient
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "client-details--name mb-5 bg-warning p-10 radius-10",
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.order.ClientId))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c(
                                  "editable-text",
                                  {
                                    attrs: { value: _vm.order.client.Email },
                                    on: {
                                      save: function ($event) {
                                        return _vm.setClient(_vm.order, $event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.order.client.Email) +
                                        " "
                                    ),
                                    _c("i", {
                                      staticClass: "fie-icon_edit",
                                      attrs: { title: "changer le client" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "client-details--name mb-5" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.order.client.FirstName) +
                          " " +
                          _vm._s(_vm.order.client.LastName) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "client-details--phone mb-5" }, [
                      _c(
                        "a",
                        { attrs: { href: "tel:" + _vm.order.client.Mobile } },
                        [_vm._v(_vm._s(_vm.order.client.Mobile))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "client-details--mail mb-5" }, [
                      _c("div", [
                        _c(
                          "a",
                          {
                            attrs: { href: "mailto:" + _vm.order.client.Email },
                          },
                          [_vm._v(_vm._s(_vm.order.client.Email))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "client-details--date mb-5" }, [
                      _c("div", [
                        _vm._v(
                          "le " + _vm._s(_vm.utcToLocal(_vm.order.OrderDate))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.order.email_state_info
                      ? _c("div", { staticClass: "mb-5 text-danger" }, [
                          _c("div", [_vm._v("Erreur à l'envoi du mail")]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "order-details-summary mt-30 text-grey2" },
              [
                _vm.order.Table == -18
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-date flex-start-start pb-10",
                      },
                      [_vm._m(0), _vm._v(" "), _vm._m(1)]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.Table != -18
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-date flex-start-start pb-10",
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Quand")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.extractOrderDay(_vm.order.PickupTimeDate)
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.Table != -18
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-time flex-start-start pb-10",
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("À quelle heure")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.extractOrderTime(_vm.order.PickupTimeDate)
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.SaleAreaId != _vm.SALE_AREAS.DELIVERY
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-location flex-start-start pb-10",
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Où")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.order.shop.DefaultName) +
                                  ", " +
                                  _vm._s(_vm.order.shop.Address1) +
                                  " " +
                                  _vm._s(_vm.order.shop.Address2) +
                                  ",\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.order.shop.Zip) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v(_vm._s(_vm.order.shop.City)),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.SaleAreaId == _vm.SALE_AREAS.DELIVERY
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-location flex-start-start pb-10",
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Livrée")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "fsize-12 color-1" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.order.address.PlusCode) +
                                  " " +
                                  _vm._s(_vm.order.address.Company) +
                                  " " +
                                  _vm._s(_vm.order.address.Address) +
                                  ", " +
                                  _vm._s(_vm.order.address.Zip) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v(_vm._s(_vm.order.address.City)),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.Comment
                  ? _c(
                      "li",
                      {
                        staticClass:
                          "order-details-summary-comment flex-start-start pb-10",
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-details-summary-details h-100 flex-center-start flex-column",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "fsize-10 text-uppercase" },
                              [_vm._v("Commentaire")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fsize-12 color-1",
                                staticStyle: { "word-break": "break-all" },
                              },
                              [_vm._v(_vm._s(_vm.order.Comment))]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.order.stuart_job_id
          ? _c(
              "div",
              {
                staticClass:
                  "order-details--stuart collapseBlock p-20 bg-bo-grey4",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-between-center cursor-pointer",
                    on: {
                      click: function ($event) {
                        _vm.isCollapsed = !_vm.isCollapsed
                        _vm.getJob()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "flex-start-center" }, [
                      _c("i", {
                        staticClass: "fie-icon_delivery fsize-26 mr-10",
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "flex-start-center" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-bold color-grey1 text-uppercase fsize-16",
                            },
                            [_vm._v("Livraison")]
                          ),
                          _vm._v(" "),
                          !_vm.isCollapsed
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-center-center pill text-white bg-bo-s2 cursor-pointer mx-5 fsize-14 line-height-1",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.getJob()
                                      _vm.isCollapsed = false
                                    },
                                  },
                                },
                                [
                                  _c("span", [_vm._v("Actualiser")]),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.stuartProcessing,
                                        expression: "stuartProcessing",
                                      },
                                    ],
                                    staticClass: "loading ml-5",
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.stuartProcessing,
                                        expression: "!stuartProcessing",
                                      },
                                    ],
                                    staticClass: "fie-icon_reload ml-5",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-bold color-grey2 fsize-10" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tLivraison prévue à:\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.stuart_job
                                    ? _vm
                                        .moment(_vm.stuart_job.dropoff_at)
                                        .format("HH:mm")
                                    : ""
                                ) +
                                "\n\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("collapse-indicator", {
                      attrs: { open: !_vm.isCollapsed },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isCollapsed,
                          expression: "!isCollapsed",
                        },
                      ],
                    },
                    [
                      _c("stuart-job", { attrs: { job: _vm.stuart_job } }),
                      _vm._v(" "),
                      _vm.order.stuart_status
                        ? _c("div", [
                            _vm.order.stuart_status
                              ? _c("div", { staticClass: "panel-danger" }, [
                                  _c("div", { staticClass: "panel-heading" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tErreur pour la livraison : " +
                                        _vm._s(
                                          _vm.order.stuart_status.message
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.order.stuart_status.data,
                                        function (values, k) {
                                          return _c(
                                            "li",
                                            { key: k },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(k) +
                                                  ":\n\t\t\t\t\t\t\t\t\t\t"
                                              ),
                                              _vm._l(
                                                values,
                                                function (value, i) {
                                                  return _c("div", { key: i }, [
                                                    _vm._v(_vm._s(value)),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "order-details--cart collapseBlock bg-bo-grey4 p-20 radius-5 radius-top-0",
          },
          [
            _c(
              "div",
              { staticClass: "order-cart minicart" },
              [_c("order-items", { attrs: { order: _vm.order } })],
              1
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "pushRightSidebar--bottom minHeight order-details-bottom flex-start-end pos-sticky bottom-0 p-20 bg-white",
      },
      [_c("order-summary-mini", { attrs: { order: _vm.order } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "minHeight bottom-0 p-20 bg-white" },
      [_c("star-rating", { attrs: { order: _vm.order, isAdmin: true } })],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "order-details-summary-details h-100 flex-center-start flex-column",
      },
      [
        _c("div", { staticClass: "fsize-10 text-uppercase" }, [
          _vm._v("Commande Borne"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_time" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_pin" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_delivery" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "radius-circle bg-grey3 fsize-20 no-line-height p-10 mr-20",
      },
      [_c("i", { staticClass: "fie-icon_help" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }